import {toast} from 'react-toastify';
import {localizationService, errorFormatterService} from 'core/services';

class NotificationStore {
    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    success(message, duration = null) {

        return showToast(localizationService.t(message), {
            className: 'green-background',
            bodyClassName: 'grow-font-size',
            progressClassName: 'fancy-progress-bar',
            autoClose: duration
        });
    }

    warning(message, duration = null) {
        return showToast(localizationService.t(message), {
            className: 'orange-background',
            bodyClassName: 'grow-font-size',
            progressClassName: 'fancy-progress-bar',
            autoClose: duration
        });
    }

    error(message, data = null, duration = null) {
        if(data) {
            const { headers, config, status } = data;
            errorFormatterService.getErrorObject(data.data, data.message, status, headers, config);
        }

        const text = formatNotificationMessage(message);

        return showToast(text, {
            className: 'red-background',
            bodyClassName: 'grow-font-size',
            progressClassName: 'fancy-progress-bar',
            autoClose: duration
        });
    }

    dismiss(toastId) {
        toast.dismiss(toastId);
    }
}

function showToast(message, options) {
    return toast(message, options);
}

function formatNotificationMessage(message) {
    if (message == null) return '';

    if (Array.isArray(message)) {
        return message.map(formatNotificationMessage).filter(Boolean).join('\n');
    }

    if (typeof message === 'object') {
        const text = message.message || message.Message || message.errorMessage || message.text;
        if (text) return formatNotificationMessage(text);
        return localizationService.t(JSON.stringify(message));
    }

    const str = String(message);
    return str.includes(' ') ? str : localizationService.t(str);
}

export default NotificationStore;
